const decodeId = id => decodeURI(atob(id))

export default decodeId
